import React, { useState } from 'react'
import { device, IconSvg, LimitCharacters, Main_Plain } from 'monica-alexandria'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import NoImg from '../../../assets/NoImage.png'
import { useCRMContext } from '../../../context/CrmContext'

let minioImgUrl = process.env.REACT_APP_MINIO_PROTOCOL +
                    process.env.REACT_APP_MINIO_HOST + 
                    process.env.REACT_APP_MINIO_PORT+ '/' +
                    process.env.REACT_APP_MINIO_DAILYPROFIT_BUCKET ;


const Tooltip = styled.span`
    position: absolute;
    left: 100%;
    border: ${p => p.theme.mid} 1px solid;
    /* top: 1rem; */
    transform: translateY(0) translateX(10px);
    background: ${p => p.theme.low};
    color: ${p => p.theme.color};
    padding: var(--smallPads);
    border-radius: var(--smallRadius);
    white-space: nowrap;
    opacity: 0;
    margin-left: 0.5rem;
    pointer-events: none;
    transition: opacity .3s, transform .3s;
    font-family: "fontBold";
    font-size: 1.2rem;
    
`

const HomeToolbar = styled.div`
    /*
    Previous version:
    position: fixed;
    top: 6rem;
    left: 0;
    z-index: 50;
    width: 100%;
    max-width: ${p => p.expand ? "30rem" : "8.2rem"};
    */
    position: sticky;
    top: 6rem;
    left: 0;
    z-index: 50;
    flex: 0 0 ${p => p.expand ? "30rem" : "8.2rem"};
    height: calc(100vh - 6rem);
    padding-top: 2rem;
    border-top: 2px solid ${p => p.theme.low};
    border-right: 2px solid ${p => p.theme.low};
    width: ${p => p.expand ? "30rem" : "8.2rem"};
    background: ${p => p.theme.background};
    min-width: ${p => p.expand ? "30rem" : "8.2rem"};
    overflow: visible;
    transition: width .3s ease, min-width .3s ease, flex-basis .3s ease;

    @media ${device.sm} {

    }
`

const HomeToolbarMoreTools = styled.div`
    position: absolute;
    bottom: 1rem;
    left: 4rem;

    @media ${device.sm} {
        display: none;
    }
`

const HomeExpand = styled.div`
    /* display: none; */
/* 
    @media ${device.sm} { */
        display: block;
        position: absolute;
        right: 0;
        top: 2px;
        transform: translateX(50%);
        height: 4rem;
        width: 4rem;
        background: ${p => p.theme.low};
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        border: 2px solid ${p => p.theme.background};
        cursor: pointer;

        svg{
            width: var(--largeIcon);
            fill: ${p => p.theme.color};
            transform: ${p => p.expand ? "rotate(180deg)" : "rotate(0deg)"};
            transition: transform .5s;
        }
    /* } */
`

const HomeToolbarList = styled.div`
        padding-bottom: 1rem;
    h6{
        padding: 0 1rem .5rem 4rem;
        color: var(--greyDark);
        font-family: "fontBold";
        white-space: nowrap;
        display: ${p => p.expand ? "block" : "none"};

    }

    ul{
        li{
            display: flex;
            align-items: center;
            justify-content: ${p => p.expand ? "left" : "center"};
            gap: 1rem;
            position: relative;
            /* padding:  .5rem 2rem .5rem 4rem; */
            padding: ${p => p.expand ? "0.5rem 1rem 0.5rem 4rem" : "0.5rem 1rem 0.5rem 1rem"};
            
            cursor: pointer;
            /* transform:${p => p.expand ? "translateX(0)" : "translateX(-1rem)"};
            transition: transform .5s; */

            h5{
                display: ${p => p.expand ? "block" : "none"};
            }

            svg{
                width: 1.5rem;
                fill: ${p => p.theme.color};
            }

            img{
                border-radius: 5px;
                height: 2rem;
                width: 2rem;
                object-fit: cover;
            }
            
            &:hover ${Tooltip} {
                /* opacity: ${p => p.expand ? 0 : 1} !important; */
                transform: translateX(0) scale(1);
            }
            &:hover{
                background: ${p => p.theme.low};
                transition: background .5s;
            }
          
          

        }
    }


`

const HomeToolbarDoitOnly = styled(HomeToolbarList)`
`

const HomeToolbarBusiness = styled(HomeToolbarList)`
`

const HomeToolbarSettings = styled(HomeToolbarList)`
    padding-top: 2rem;

    li {
        cursor: pointer;

        &.active {
            background: ${p => p.theme.mid};
        h5 {
            color: var(--main); /* your primary color */
        }
        svg {
            fill: var(--main); /* optional: highlight the icon too */
        }
        }
    }
`





const QuestList = styled.div`   
    padding: 1rem 0;
    border-top: ${p => p.first ? '0' : `2px solid ${p.theme.low}`};


    .MainPlain{
        margin: 0 auto;
        display: ${p => p.expand ? "block" : "none"};

    }
    h6{
        padding: 0 1rem .5rem 4rem;
        color: var(--greyDark);
        font-family: "fontBold";
        white-space: nowrap;

        display: ${p => p.expand ? "block" : "none"};
        transform:  ${p => p.expand ? "translateX(0)" : "translateX(-2rem)"};
        transition: transform .5s;
    }

   
    ul{

        li{
            /* padding: .5rem 1rem; */
            padding:${p => p.expand ? "0.5rem 1rem 0.5rem 4rem" : "0.5rem 1rem 0.5rem 1rem"};
            
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: ${p => p.expand ? "left" : "center"};
     
            /* width: ${p => p.expand ? "100%" : "100%"}; */
            /* transform:${p => p.expand ? "translateX(0)" : "translateX(-1rem)"}; */

            gap: 1rem;


            h5{
                display: ${p => p.expand ? "block" : "none"};
            }

            svg{
                width: 1.8rem;
                fill: ${p => p.theme.color};
            }


             img{
                width: 2rem;
                height: 2rem;
                border-radius: 5px; 
                object-fit: cover;
                /* transform:  ${p => p.expand ? "translateX(0)" : "translateX(-2rem)"}; */
                transition: transform .5s;

            }   

            &.active{
                background: ${p => p.theme.low};
            }
            p{
                font-size: 1.5rem;
                  display: ${p => p.expand ? "block" : "none"};
            }

            &:hover ${Tooltip} {
                opacity: ${p => p.expand ? 0 : 1} !important;
                transform: translateX(0) scale(1);
            }
            &:hover{
                background: ${p => p.theme.mid};
            }
        }
    }   

`

const HomeToolbarBusinessItem = styled.div`

    ul{
        max-height: 30rem;
        overflow: auto;
        li{
            display: flex;
            align-items: center;
            gap: 1rem;

            svg{
                fill: var(--main);
                width: 1.2rem;
            }
        }
    }
`

const HomeToolbarGeneral = styled(HomeToolbarList)`
    /* &:hover ${Tooltip} {
        opacity: ${p => p.expand ? 0 : 1} !important;
        transform: translateX(0) scale(1);
    } */
`

const HomeToolbarActive = styled(HomeToolbarList)`
`

const HomeToolbarArchived = styled(HomeToolbarList)`
`

const HomeToolbarSub = styled.div`
    position: relative;
    height: 3rem;

    span{
        position: absolute;
        left: 0;
        top: 50%;
        height: 2px;
        width: 100%;
        background: ${p=>p.theme.low};
        transform: translateY(-50%);
    }
`
const HomeToolbarSubTitle = styled.div`
    display: flex;
    align-items: center;
    gap:1rem;
    padding-left: 2rem;
`

const HomeToolbarTop = styled.div`
    height: 90vh;
    overflow-y: auto;
    scrollbar-width: thin;
    padding-bottom: 2rem;
        overflow-x: visible;
  
`
export default function Crm_Toolbar(props) {
        const [expand, setExpand] = useState(true);
        const {t} = useTranslation();
        const navigate = useNavigate();
        const location = useLocation();
        const {lang, questId} = useParams();
        const [showAllArchived, setShowAllArchived] = useState(false);
        const { quests, archivedQuests } = useCRMContext();
        function getQuestName(quest) {
        return quest?.name ||
            `${quest?.questionnaires[0]?.answer} ${LimitCharacters(quest?.questionnaires[1]?.answer, 10)} | ${LimitCharacters(quest?.Meta?.facebookPageName, 8)}`;
        }

        function getAdImageUrl(quest){
            if (quest.adInfo?.thumbnail && quest.adInfo?.thumbnail !== 'default.jpg') {
                return quest?.adInfo?.thumbnail;
            }
            else if (quest?.adInfo?.visualElement) {
                return `${minioImgUrl}/${quest?.userId}/${quest?.adInfo?.visualElement}`;
            }
            else return NoImg;
        // return false;
        };

        const MAX_ARCHIVED = 5;

        const visibleArchivedQuests = showAllArchived
        ? archivedQuests
        : archivedQuests?.slice(0, MAX_ARCHIVED);

        
        const isExport = location.pathname.includes('/crm/export');
        const permission = true; // checkPermissions('Doitforme')
        
  return (
  <HomeToolbar expand={expand}>
        <HomeExpand expand={expand} onClick={() => setExpand(!expand)} >
            <IconSvg Icon="Next" />
        </HomeExpand>
            <HomeToolbarTop>
            <QuestList first expand={expand}>
                {/* <HomeToolbarSub>
                    <span></span>
                </HomeToolbarSub> */}
                    <h6>{t("General")}</h6>
                    <ul>
                        <li className={!questId && !isExport ? 'active' : ''} onClick={()=> navigate(`/${lang}/crm`)}>
                            <IconSvg Icon="Workspace" />
                            <h5>{t("Boards")}</h5>
                            {!expand && <Tooltip>{t("Boards")}</Tooltip>}
                        </li>
                        <li className={isExport ? 'active' : ''} onClick={()=> navigate(`/${lang}/crm/export`)}>
                            <IconSvg Icon="Download" />
                            <h5>{t("Export data")}</h5>
                            {!expand && <Tooltip>{t("Export data")}</Tooltip>}
                        </li>
                    </ul>
            </QuestList>

            {/* <Dropdown_ label={t("Selected quest")}> */}
                {/* <select value={selectedQuestId || ""} onChange={(e) => setSelectedQuestId(e.target.value)} > */}
                <QuestList expand={expand}>
                    <h6>{t("Active Quests")}</h6>
                    <ul>
                        {quests?.map((quest, i) => (
                            <li value={quest._id} key={i}
                            className={String(questId) === String(quest._id) ? 'active' : ''}
                            onClick={() => navigate(`/${lang}/crm/board/${quest._id}`)}
                            >
                                 <img src={getAdImageUrl(quest)} alt="Ad" />
                                {expand && <p>{getQuestName(quest)}</p>}
                                {!expand &&  <Tooltip>{getQuestName(quest)}</Tooltip>}
                            </li>
                        ))}
                    </ul>
                </QuestList>
            
            <QuestList expand={expand}>
                <h6>{t("Archived Quests")}</h6>
                <ul>
                    {visibleArchivedQuests?.map((quest, i) => (
                    <li value={quest._id} key={i}
                        className={String(questId) === String(quest._id) ? 'active' : ''}
                        onClick={() => navigate(`/${lang}/crm/board/${quest._id}`)}
                    >
                        <img src={getAdImageUrl(quest)} alt="Ad" />
                        {expand && <p>{getQuestName(quest)}</p>}
                        {!expand &&  <Tooltip>{getQuestName(quest)}</Tooltip>}
                    </li>
                    ))}
                </ul>

                {archivedQuests?.length > MAX_ARCHIVED && (
                    <Main_Plain
                        text={showAllArchived ? t("Show less") : t("View all")}
                        onClick={() => setShowAllArchived(prev => !prev)}
                        size='small'
                    />
                )}
                </QuestList>

            </HomeToolbarTop>
    </HomeToolbar>
  )
}
